import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  FormControlLabel,
  TextField,
  Box,
  Button,
  Grid,
  DialogActions,
} from "@mui/material";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { Close as CloseIcon, PhotoCamera } from "@mui/icons-material";
import { createClient, updateClient, uploadClientImg } from "../../redux/actions/client.actions";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Toastify } from "../../services/toastify/toastifyContainer";
import { FaPaperPlane, FaEdit } from "react-icons/fa";
import ButtonOnly from "../../components/Comman/button-new/buttonNew";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": { padding: theme.spacing(2) },
  "& .MuiDialogActions-root": { padding: theme.spacing(1) },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon color="error" />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};



const CreateModel = (props) => {
  const dispatch = useDispatch();

  const { openModal, handleModal, edit, setEdit, updateData } = props;
  // const { client } = useSelector((state) => state?.clientReducer);
  const [id, setId] = useState(null)
  const [clientData, setclientData] = useState({});
  const [logoData, setLogoData] = useState(null);
  const [iconData, setIconData] = useState(null);

  const handleClose = () => {
    setIconData(null);
    setLogoData(null);
    handleModal();
    setEdit(false)
  };


  const handleLogoChange = async (e) => {
    const size = e.target.files[0].size;
    if (size < 50000) {
      const file = e.target.files[0]
      const formData = new FormData();
      formData.append("image", file);
      const img = await dispatch(uploadClientImg(formData))
      setLogoData(img);
    } else {
      Toastify({ data: "error", msg: "Size is too large" })
    }
  };

  const handleIconChange = async (e) => {
    const size = e.target.files[0].size;
    if (size < 50000) {
      const file = e.target.files[0]
      const formData = new FormData();
      formData.append("image", file);
      const img = await dispatch(uploadClientImg(formData))
      setIconData(img);
    } else {
      Toastify({ data: "error", msg: "Size is too large" })
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!clientData || !clientData.name || !clientData.slug || !logoData || !iconData) {
      alert("PLEASE UPLOAD THE CLIENT NAME AND UNIQUE SLUG");
      handleModal(true)
    } else {
      const obj = {
        name: clientData.name,
        slug: clientData.slug,
        logo: logoData,
        icon: iconData

      }
      if (edit) {
        dispatch(updateClient(id, obj))
      } else {
        dispatch(createClient(obj));
      }

      handleClose();
      setclientData({});
      setIconData(null);
      setLogoData(null);
      setEdit(false)
    }
  };

  const handleChange = (e) => {
    setclientData({ ...clientData, [e.target.id]: e.target.value });
  };
  useEffect(() => {
    if (edit) {
      setId(updateData?.client_id)
      setLogoData(updateData?.logo)
      setIconData(updateData?.icon)
      setclientData({
        name: updateData?.name,
        slug: updateData?.slug
      })
    }
  }, [edit, updateData])



  return (
    <form onSubmit={handleSubmit}>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={openModal}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
          sx={{ textAlign: "center", backgroundColor: "rgba(0, 165, 162, 0.7)", color: "white" }}
        >
          {edit ? `Update Client` : `Create Client`}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Box
            sx={{
              "& .MuiTextField-root": { mt: 4, ml: 6 },
            }}
          >
            <Grid container>
              <Grid
                item
                direction="column"
                columnSpacing={2}
              >
                <FormControlLabel
                  control={
                    <TextField
                      required
                      key="name"
                      label="Client Name"
                      onChange={handleChange}
                      id="name"
                      placeholder="Client Name"
                      value={clientData.name}
                    />
                  }
                />
                <FormControlLabel
                  control={
                    <TextField
                      required
                      key="Slug"
                      label="Slug"
                      onChange={handleChange}
                      id="slug"
                      placeholder="Slug"
                      value={clientData.slug}
                    />
                  }
                />
              </Grid>
              <Grid
                container
                item
                sx={{ justifyContent: "space-evenly" }}
                direction="row"
                columnSpacing={8}
              >
                <FormControlLabel
                  control={
                    <Grid
                      container
                      item
                      direction="column"
                      sx={{ ml: 10, mt: 3 }}
                    >
                      <Button
                        required
                        variant="outlined"
                        startIcon={<PhotoCamera />}
                        component="label"
                        onChange={handleLogoChange}
                      >
                        Upload Logo
                        <input
                          hidden
                          accept="image/*"
                          type="file"
                        />
                      </Button>
                      {logoData !== null && (

                        <LazyLoadImage
                          alt="image not uploaded"
                          src={logoData}
                          className="object-fit-cover mt-4"
                          width={'100px'}
                          style={{ marginLeft: "2.5rem" }}
                        />
                      )}
                    </Grid>
                  }
                />
                <FormControlLabel
                  control={
                    <Grid
                      container
                      item
                      direction="column"
                      sx={{ ml: 10, mt: 3 }}
                    >
                      <Button
                        required
                        variant="outlined"
                        startIcon={<PhotoCamera />}
                        component="label"
                        onChange={handleIconChange}
                      >
                        Upload Icon
                        <input
                          hidden
                          accept="image/*"
                          type="file"
                        />
                      </Button>
                      {iconData !== null && (
                        <LazyLoadImage
                          alt="image not uploaded"
                          src={iconData}
                          className="object-fit-cover mt-4"
                          width={'100px'}
                          style={{ marginLeft: "2.5rem" }}
                        />
                      )}
                    </Grid>
                  }
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <ButtonOnly
            buttonLabel={edit ? "Update" : "Submit"}
            buttonIcon={edit ? <FaEdit /> : <FaPaperPlane />}
            buttonClick={handleSubmit}
          />
        </DialogActions>
      </BootstrapDialog>
    </form>
  );
};

export default CreateModel;
